(() => {
  if (!window.MutationObserver) return;

  const desktop = window.matchMedia('(min-width: 769px)');

  class SlideshowVideos {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('.slideshow__slide'));
      this.visible = true;

      this.sync = this.sync.bind(this);

      const classWatcher = new MutationObserver(this.sync);
      this.slides.forEach((slide) => {
        classWatcher.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });

      if (desktop.addEventListener) desktop.addEventListener('change', this.sync);

      // Une vidéo qui tourne hors de l'écran ne sert à personne.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }).observe(root);
      }

      this.sync();
    }

    sync() {
      const active = this.slides.find((slide) => slide.classList.contains('is-active'));

      this.slides.forEach((slide) => {
        slide.querySelectorAll('video[data-slide-video-for]').forEach((video) => {
          const wanted = this.visible
            && slide === active
            && video.dataset.slideVideoFor === (desktop.matches ? 'desktop' : 'mobile');

          if (wanted) {
            SlideshowVideos.play(video);
          } else {
            SlideshowVideos.pause(video);
          }
        });
      });
    }

    static play(video) {
      if (!video.dataset.src) return;

      if (!video.getAttribute('src')) {
        video.muted = true;
        video.setAttribute('src', video.dataset.src);
      }

      const started = video.play();
      if (started) {
        started.then(() => video.classList.add('is-playing')).catch(() => {});
      } else {
        video.classList.add('is-playing');
      }
    }

    static pause(video) {
      if (!video.getAttribute('src')) return;
      video.pause();
      video.classList.remove('is-playing');
    }
  }

  document.querySelectorAll('slide-show').forEach((root) => {
    if (root.querySelector('video[data-slide-video-for]')) new SlideshowVideos(root);
  });
})();
